// extracted by mini-css-extract-plugin
export default {"form":"app-react-portainer-access-control-AccessControlPanel-AccessControlPanelForm-module__form"};